import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import Audiobutton from "../Twilio/AudioCall/AudioButton";
import VideoButton from "../Twilio/VideoCall/VideoButton";
import ScreenShareButton from "../Twilio/ScreenShare/ScreenShareButton";
import TakePhotoButton from "./TakePhotoButton";
import FlashButton from "./FlashButton";
import EndCallButton from "./EndCallButton";
import MarkupButton from "./MarkupButton";
import ExtractTextButton from "./ExtractTextButton";
import LivePointerButton from "./LivePointerButton";
import RecordingButton from "./RecordingButton";
import MeasurementButton from "./MeasurementButton";
import ARMarkupButton from "./ARMarkupButton/ARMarkupButton";
import LiveLocationButton from "./LiveLocationButton";
import ParticipantsListButton from "./ParticipantsListButton";
import UploadFilesButton from "./UploadFilesButton";
import NotesButton from "../Notes/NotesButton";
import BookmarkButton from "../Bookmarks/BookmarkButton";
import ChatButton from "./ChatButton";
import IncomingChatBubble from "../Chat/IncomingChatBubble";
import { CALL_BODY_SCREEN } from "../../constants/Constants";
import WhisperButton from "./WhisperButton";
import MediateButton from "./MediateButton";
import { InviteParticipantButton } from "../CallScreens/CallTopbar/InviteParticipant/InviteParticipantButton";
import useBottomMenuClass from "../../hooks/useBottomMenuClass";
import { getLocalBrowserInfo, isiPhoneOnlyDevice } from "../../shared/utility";
import { BROWSER } from "../../constants/BottomMenuConstants";
import LiveCaptionsButton from "./LiveCaptionsButton";
import AudioTranslationButton from "./AudioTranslationButton";
import AskAIButton from "./AskAIButton";

const BottomMenuBar = React.memo(() => {
    const [numOfItems, setNumOfItems] = useState(0);
    const [breakWidths, setBreakWidths] = useState([]);
    const [availableSpace, setAvailableSpace] = useState(0);
    const [numOfVisibleItems, setNumOfVisibleItems] = useState(0);
    const [requiredSpace, setRequiredSpace] = useState(0);
    const [isHiddenLinksVisible, setIsHiddenLinksVisible] = useState(false);

    const { currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const { notesList } = useSelector((state) => state.notes);
    useBottomMenuClass();
    const localisedValues = useLanguageChange();

    /*
        Handle to set the total visible menus number
        Handle the array of all menu width break point
    */
    useEffect(() => {
        const visibleManus = document.getElementById("visible-links");
        const childrenWidths = Array.from(visibleManus.children).map((child) => child.offsetWidth);
        setNumOfItems(visibleManus.children.length);
        const breakWidthsArray = childrenWidths.reduce((acc, width, index) => {
            if (index > 0) {
                acc.push(acc[index - 1] + width);
            } else {
                acc.push(width);
            }
            return acc;
        }, []);
        setBreakWidths(breakWidthsArray);

        const classExist = document.getElementById("call-action-menu")?.classList?.contains("active");
        if (!classExist) {
            /* Add active class after 1 second delay so taht all button get proper position before it come back to display */
            setTimeout(() => {
                document.getElementById("call-action-menu")?.classList?.add("active");
            }, 500);
        }
    }, []);

    /* Handle the more button is visible or not */
    useEffect(() => {
        const hiddenLinks = document.getElementById("hidden-links");
        if (hiddenLinks.children.length > 0) {
            setIsHiddenLinksVisible(true);
        } else {
            setIsHiddenLinksVisible(false);
        }
    }, [numOfVisibleItems]);

    useEffect(() => {
        const visibleLinks = document.getElementById("visible-links");
        const hiddenLinks = document.getElementById("hidden-links");

        const handleResize = () => {
            setAvailableSpace(visibleLinks.offsetWidth - 10);
            setNumOfVisibleItems(visibleLinks.children.length);
            setRequiredSpace(breakWidths[numOfVisibleItems - 1]);

            if (requiredSpace > availableSpace) {
                const lastChild = visibleLinks?.lastElementChild;
                hiddenLinks?.insertBefore(lastChild, hiddenLinks.firstChild);
                setNumOfVisibleItems((prev) => prev - 1);
            } else if (availableSpace > breakWidths[numOfVisibleItems]) {
                console.log("numOfVisibleItems ==>", numOfVisibleItems);
                const firstChild = hiddenLinks?.firstElementChild;
                if (firstChild) {
                    visibleLinks?.appendChild(firstChild);
                    setNumOfVisibleItems((prev) => prev + 1);
                }
            }
            // Find the div inside the #call-action element
            const rightSpaceDiv = document.querySelector("#visible-links #right-space-div");
            if (rightSpaceDiv !== null) {
                // If it exists, remove the class
                document.querySelector("#visible-links")?.classList?.remove("call-action-align");
            } else {
                // If it doesn't exist, add the class
                document.querySelector("#visible-links")?.classList?.add("call-action-align");
            }

            const tabbarchatdiv = hiddenLinks?.querySelector("#chat-action-button");

            // call-action-moremenu-hidden
            if (hiddenLinks) {
                if (tabbarchatdiv?.length > 0 && hiddenLinks?.children?.length == 1) {
                    const callActionMoremenu = document.getElementById("call-action-moremenu");
                    if (callActionMoremenu) {
                        callActionMoremenu.classList.add("d-none");
                    }
                    // Remove 'show' class from '#call-action-dropdown'
                    const callActionDropdown = document.getElementById("call-action-dropdown");
                    if (callActionDropdown) {
                        callActionDropdown.classList.remove("show");
                    }

                    // Remove 'show' class from '#call-action-moremenu-dropdown'
                    const callActionMoremenuDropdown = document.getElementById("call-action-moremenu-dropdown");
                    if (callActionMoremenuDropdown) {
                        callActionMoremenuDropdown.classList.remove("show");
                    }
                }
            }
            if (tabbarchatdiv) {
                document.getElementById("mob-chat-incomming-msg")?.classList.add("chat-hide-menu");
            } else {
                document.getElementById("mob-chat-incomming-msg")?.classList.remove("chat-hide-menu");
            }
        };

        const handleOrientationChange = () => {
            const currentOrientation = window.innerHeight > window.innerWidth ? "portrait" : "landscape";
            const localBrowserInfo = getLocalBrowserInfo();
            /* Only trigger the logic when changing to portrait in iphone/ipad chrome */
            if (
                isiPhoneOnlyDevice() &&
                localBrowserInfo.browserName.toLowerCase() === BROWSER.CHROME &&
                currentOrientation === "portrait" &&
                visibleLinks.children.length
            ) {
                /* Handle the change from landscape to portrait */
                setNumOfVisibleItems(visibleLinks.children.length - 1);
            }
        };

        window.addEventListener("orientationchange", handleOrientationChange);
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => {
            window.removeEventListener("orientationchange", handleOrientationChange);
            window.removeEventListener("resize", handleResize);
        };
    }, [breakWidths, numOfItems, numOfVisibleItems, availableSpace, requiredSpace]);

    useEffect(() => {
        // when more button will open z-index will adjust accordingly
        const callActionDropdown = document.getElementById("call-action-dropdown");
        callActionDropdown?.addEventListener("show.bs.dropdown", function () {
            document.getElementById("call-action-menu")?.classList?.add("call-action-moremenu-open");
        });

        callActionDropdown?.addEventListener("hide.bs.dropdown", function () {
            document.getElementById("call-action-menu")?.classList?.remove("call-action-moremenu-open");
        });
    }, [isHiddenLinksVisible]);

    return (
        <>
            <div className='call-action-menu' id='call-action-menu'>
                <div className='call-action' id='visible-links'>
                    <div className='left-space'></div>
                    <EndCallButton />
                    <WhisperButton />
                    <MediateButton />
                    <Audiobutton />
                    <VideoButton />
                    <ScreenShareButton />
                    <TakePhotoButton />
                    <FlashButton />
                    <MarkupButton />
                    <ExtractTextButton />
                    <LivePointerButton />
                    <RecordingButton />
                    <div className='right-space' id='right-space-div'></div>
                    <MeasurementButton />
                    <ARMarkupButton />
                    <UploadFilesButton />
                    <LiveCaptionsButton />
                    <AudioTranslationButton />
                    <LiveLocationButton />
                    <NotesButton notesList={notesList} />
                    <AskAIButton />
                    <ChatButton />
                    <BookmarkButton />
                    <ParticipantsListButton />
                </div>
                <div className={clsx("dropdown call-action-moremenu", !isHiddenLinksVisible ? "d-none" : "")} id='call-action-moremenu'>
                    <button
                        className='btn dropdown-toggle triangle-none moremenu-btn'
                        type='button'
                        id='call-action-dropdown'
                        data-bs-toggle='dropdown'
                        aria-expanded='false'
                        disabled={currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN}
                    >
                        <span className='action-button-icon'>
                            <span className='for-icon icon-more'></span>
                        </span>
                        <span className='for-text'>{localisedValues?.more}</span>
                    </button>
                    <div
                        className='dropdown-menu call-action-moremenu-dropdown right'
                        aria-labelledby='call-action-moremenu'
                        id='call-action-moremenu-dropdown'
                    >
                        <div className='dropdown-menu-in custom-scroll-thin' id='hidden-links'>
                            <InviteParticipantButton />
                        </div>
                    </div>
                </div>
            </div>
            <IncomingChatBubble isForMobile={true} />
        </>
    );
});

export default BottomMenuBar;
